import { render, staticRenderFns } from "./Mfee.vue?vue&type=template&id=b2e3c786&scoped=true"
import script from "./Mfee.vue?vue&type=script&lang=js"
export * from "./Mfee.vue?vue&type=script&lang=js"
import style0 from "./Mfee.vue?vue&type=style&index=0&id=b2e3c786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e3c786",
  null
  
)

export default component.exports